import {
  CreateSliceOptions,
  SliceCaseReducers,
  ValidateSliceCaseReducers,
  createSlice,
} from '@reduxjs/toolkit';

import { SliceReducers, ValidateSliceReducers } from './create-app-slice.types';

export const createAppSlice = <T, Reducers extends SliceReducers<T>>({
  name,
  initialState,
  reducers,
  extraReducers,
}: {
  name: string;
  initialState: T;
  reducers: ValidateSliceReducers<T, Reducers>;
  extraReducers?: CreateSliceOptions['extraReducers'];
}) => {
  return createSlice({
    name,
    initialState,
    reducers: reducers as ValidateSliceCaseReducers<T, SliceCaseReducers<T>>,
    extraReducers,
  });
};
